// Marka anahtarı normalizasyonu — backend glowytics-backend/src/utils/itemBrandCanonical.js
// `brandKey` kuralıyla AYNI: NFKD → diakritik sil → ı/İ→i → lower → [^a-z0-9] sil.
// "New Balance" / "NEWBALANCE" / "Say Sky" / "Saysky" / "Haglöfs" / "HAGLOFS" tek anahtara iner.
export function brandKey(s) {
  return String(s == null ? '' : s)
    .replace(/İ/g, 'i')
    .replace(/ı/g, 'i')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}

// Metni segmentlere (harf/rakam dışı ayıraçlar) böler; diakritikli harfler segment içinde kalır.
function segments(name) {
  return String(name)
    .split(/[^\p{L}\p{N}]+/u)
    .filter(Boolean);
}

// `name` içinde ardışık 1..maxWin segmentin birleşimi, normalize `pattern` ile TAM eşit mi?
// Kısa anahtarlarda ("ON") alt-dize eşleşmesi yapılmaz: "CONVERSION" eşleşmez.
export function segmentMatchesBrand(name, pattern, maxWin = 3) {
  const target = brandKey(pattern);
  if (!target) return false;
  // Çok kısa anahtarlar (ON, 4T2…) yalnız tek segmentle eşleşir; "O N" gibi birleşimler sayılmaz.
  if (target.length < 4) maxWin = 1;
  const segs = segments(name).map(brandKey).filter(Boolean);
  for (let i = 0; i < segs.length; i++) {
    let acc = '';
    for (let w = 0; w < maxWin && i + w < segs.length; w++) {
      acc += segs[i + w];
      if (acc === target) return true;
      if (acc.length >= target.length) break;
    }
  }
  return false;
}
